import { useEffect, useState } from "react";
import { ArrowDown, Server, ShieldCheck, CheckCircle2 } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { api } from "@/lib/api";
import { LAYERS, INFRA, FLOW, COMPLIANCE } from "@/lib/architecture";

export default function ArchitecturePage() {
  const { t } = useApp();
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/architecture").then((r) => setData(r.data)); }, []);
  return (
    <div className="space-y-5 px-4 pt-4" data-testid="architecture-page">
      <div>
        <h1 className="text-2xl font-bold">{t("architecture")}</h1>
        <p className="mt-1 rounded-lg bg-[hsl(var(--gold-soft))] p-2 text-xs font-medium">Sandbox – every connector is simulated. Nothing here talks to a real government system.</p>
      </div>
      {data && (
        <div className="grid grid-cols-3 gap-2 text-center" data-testid="architecture-counts">
          {Object.entries(data.counts).map(([k, v]) => (
            <div key={k} className="rounded-xl border bg-card p-3 shadow-sm"><p className="text-xl font-extrabold text-primary">{v}</p><p className="text-[11px] capitalize text-muted-foreground">{k}</p></div>
          ))}
        </div>
      )}
      <div className="space-y-1">
        {LAYERS.map((l, i) => (
          <div key={l.name}>
            <div className="rounded-2xl border bg-card p-3 shadow-sm">
              <p className="mb-2 text-sm font-bold text-primary">{l.name}</p>
              <div className="flex flex-wrap gap-1.5">{l.items.map((x) => <span key={x} className="rounded-full bg-muted px-2 py-1 text-[11px]">{x}</span>)}</div>
            </div>
            {i < LAYERS.length - 1 && <ArrowDown size={16} className="mx-auto my-1 text-[#B8901F]" />}
          </div>
        ))}
      </div>
      <section className="rounded-2xl border bg-card p-3 shadow-sm">
        <p className="mb-2 flex items-center gap-2 text-sm font-bold"><Server size={15} /> Infrastructure & deployment</p>
        <ul className="grid grid-cols-2 gap-1.5 text-[11px]">{INFRA.map((x) => <li key={x} className="rounded-lg bg-muted px-2 py-1.5">{x}</li>)}</ul>
      </section>
      <section className="rounded-2xl border bg-card p-3 shadow-sm">
        <p className="mb-2 text-sm font-bold">End-to-end flow</p>
        <ol className="space-y-1 text-xs">{FLOW.map((x, i) => <li key={x} className="flex gap-2"><span className="w-5 font-bold text-primary">{i + 1}</span>{x}</li>)}</ol>
      </section>
      <section className="rounded-2xl border bg-card p-3 shadow-sm">
        <p className="mb-2 flex items-center gap-2 text-sm font-bold"><ShieldCheck size={15} /> Security, compliance & governance</p>
        <ul className="space-y-1.5 text-xs">{COMPLIANCE.map((c) => <li key={c.area} className="flex gap-2"><CheckCircle2 size={14} className="mt-0.5 shrink-0 text-[#0F5132] dark:text-emerald-400" /><span><b>{c.area}</b> — {c.status}</span></li>)}</ul>
      </section>
      {data && (
        <section className="rounded-2xl border bg-card p-3 shadow-sm">
          <p className="mb-2 text-sm font-bold">Integration registry</p>
          <ul className="space-y-1.5 text-xs">{data.integrations.map((x) => <li key={x.id} className="flex justify-between gap-2"><span>{x.name}</span><span className="shrink-0 rounded-full bg-[hsl(var(--gold-soft))] px-2 text-[10px] font-semibold">{x.mode}</span></li>)}</ul>
        </section>
      )}
    </div>
  );
}
